import { DELETE_MESSAGE_CONTENT, FETCH_ALBUMS_DEFAULT_FILTERS, FETCH_ALLOWED_OFFER_LINKS, FETCH_MESSAGE_CONTENTS, FETCH_OUTREACH_DM_DEFAULT_FILTERS, SAVE_ALLOWED_OFFER_LINKS, SAVE_MESSAGE_CONTENT } from "./actions"
import { PaginatedData } from "../../types/root"
import { AllowedOffersLink, SystemActionProps, SystemProps, DefaultAlbumFilters } from "../../types/system"

export const initialSystemState: SystemProps = {
  paginatedAllowedOffersLinks: new PaginatedData<AllowedOffersLink>(),
  defaultAlbumFilters: undefined,
  defaultOutreachDmFilters: undefined,
  messageContents: []
}

const systems = (state = initialSystemState, action: SystemActionProps) => {
  switch (action.type) {
    case FETCH_ALLOWED_OFFER_LINKS: {
      const paginatedAllowedOffersLinks =
        (action.payload?.paginatedAllowedOffersLinks as PaginatedData<AllowedOffersLink>) ||
        new PaginatedData<AllowedOffersLink>()
      return {
        ...state,
        paginatedAllowedOffersLinks
      }
    }
    case SAVE_ALLOWED_OFFER_LINKS: {
      const paginatedAllowedOffersLinks =
        (action.payload?.paginatedAllowedOffersLinks as PaginatedData<AllowedOffersLink>) ||
        new PaginatedData<AllowedOffersLink>()
      return {
        ...state,
        paginatedAllowedOffersLinks
      }
    }
    case FETCH_ALBUMS_DEFAULT_FILTERS: {
      return {
        ...state,
        defaultAlbumFilters: action.payload?.defaultAlbumFilters
      }
    }
    case FETCH_OUTREACH_DM_DEFAULT_FILTERS: {
      return {
        ...state,
        defaultOutreachDmFilters: action.payload?.defaultOutreachDmFilters
      }
    }
    case FETCH_MESSAGE_CONTENTS: {
      const messageContents = action.payload?.messageContents || []
      return {
        ...state,
        messageContents
      }
    }
    case SAVE_MESSAGE_CONTENT: {
      const messageContents = action.payload?.messageContents || []
      return {
        ...state,
        messageContents
      }
    }
    case DELETE_MESSAGE_CONTENT: {
      const messageContents = action.payload?.messageContents || []
      return {
        ...state,
        messageContents
      }
    }
    default: {
      return { ...state }
    }
  }
}

export default systems
